import React from 'react';
import { DEFAULT_POLLING_INTERVAL, DEFAULT_MAX_POLLING_TIME } from './constants.esm.js';
import { useCookiePolling } from './hooks/useCookiePolling.esm.js';

/**
 * This 'provider' simply triggers our cookie polling module
 * extracted to its own component so it may be nested inside of
 * the optional included <CookiesProvider>
 */
var LocationLitePollingProvider = function (_a) {
    var children = _a.children, _b = _a.pollingInterval, pollingInterval = _b === void 0 ? DEFAULT_POLLING_INTERVAL : _b, _c = _a.maxPollingTime, maxPollingTime = _c === void 0 ? DEFAULT_MAX_POLLING_TIME : _c;
    useCookiePolling({ maxPollingTime: maxPollingTime, pollingInterval: pollingInterval });
    return React.createElement(React.Fragment, null, children);
};

export { LocationLitePollingProvider };
//# sourceMappingURL=provider.esm.js.map
